import { AlertCircle, RefreshCw } from 'lucide-react';
import Card from '../ui/Card';

/**
 * Error fallback component for tab content
 * Provides a more contextual error UI for tab components
 */
const TabErrorFallback = ({ error, onReset, onReload }) => {
  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 duration-300">
      <Card className="p-8 text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 rounded-full p-3">
            <AlertCircle className="w-6 h-6 text-red-600" />
          </div>
        </div>

        <h3 className="text-lg font-bold text-zinc-900 mb-2">
          Unable to load this section
        </h3>

        <p className="text-zinc-600 mb-6">
          There was an error loading this content. Please try again or switch to
          another tab.
        </p>

        <div className="flex gap-3 justify-center">
          <button
            onClick={onReset}
            className="flex items-center gap-2 bg-indigo-600 text-white px-4 py-2
              rounded-lg font-medium hover:bg-indigo-700 transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            Try Again
          </button>

          <button
            onClick={onReload}
            className="bg-zinc-200 text-zinc-700 px-4 py-2 rounded-lg font-medium
              hover:bg-zinc-300 transition-colors"
          >
            Reload Page
          </button>
        </div>

        {process.env.NODE_ENV === 'development' && error && (
          <details className="mt-4 text-left">
            <summary className="text-sm text-zinc-500 cursor-pointer hover:text-zinc-700">
              Technical Details
            </summary>
            <pre className="mt-2 text-xs bg-zinc-100 p-3 rounded overflow-auto max-h-32">
              {error.toString()}
            </pre>
          </details>
        )}
      </Card>
    </div>
  );
};

export default TabErrorFallback;
